import adminMiddleware from "@/components/customer/admin/ducks/middleware"
import userMiddleware from "@/components/customer/ducks/middleware"
import internalMiddleware from "@/components/customer/internal/ducks/middleware"

export default [userMiddleware, adminMiddleware, internalMiddleware]
